import styles from './Employee.css'
import FTUEModal from './FTUEModal'
import {shouldShowEmployeeManagement, hideEmployeeManagement} from 'utils/ftue'
import {ftueCompleted} from 'mixpanel/employees/ftue'

class Employee extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showFTUE: null
    }
  }

  componentWillMount () {
    this.setState({
      showFTUE: shouldShowEmployeeManagement()
    })
  }

  render () {
    if (this.state.showFTUE === null) {
      return <div />
    } else {
      return (<div className={styles['container-full-nosub']} id='moka-employee'>
        <div className={`box-report-child ${styles['container']}`}>
          {this.props.children}
        </div>
        <FTUEModal
          show={this.state.showFTUE}
          onConfirm={this._onConfirmFTUEModal}
        />
      </div>)
    }
  }

  _onConfirmFTUEModal = () => {
    hideEmployeeManagement()
    ftueCompleted()
    this.setState({
      showFTUE: false
    })
  }
}

export default Employee



// WEBPACK FOOTER //
// ./app/pages/Employees/Employee.js